import React, { Component, useEffect, useRef, useState } from "react";
import { Link, useParams, Router } from 'react-router-dom';
import { useTranslation, initReactI18next } from "react-i18next";
import Sidebar from '../../component/Sidebar';
import Header from '../../component/Header';
import { API_URL } from "../../../config";
import backIcon from "../../../components/images/back.png";

import { csv } from 'd3';

const CreatesaveDatasession = () => {

    const userType = localStorage.getItem('userType');
    const accessToken = localStorage.getItem('accessToken');
    const session = localStorage.getItem('selectedSession');
    const userId = localStorage.getItem('user_id');
    const [sessions, setsessions] = useState([]);
    const [emgAvg, setEmgAvg] = useState(false);
    const [emgRaw, setEmgRaw] = useState(false);
    const [qfourth, setQfourth] = useState([]);
    const [qsixth, setQsixth] = useState([]);

    const [hrv, setHrv] = useState(0);
    const { t } = useTranslation();

    useEffect(() => {
        Report();
        getUser();
        getQueastiondetails()

    }, [userId]);


    const getQueastiondetails = () => {

        fetch(API_URL + "/get/question/details/by/" + userId,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': accessToken,
                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {

                    setQfourth(resp.questionDetails[0].fourth)
                    setQsixth(resp.questionDetails[0].sixth)


                });
            }
            else if (response.status == 401) {
                logout()
            }
            else {
                console.log("network error")
            }
        })

    }


    const Report = () => {
        fetch(API_URL + "/configured/report?type=1",
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': accessToken,
                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    setsessions(resp.sessions)
                    // getCsv()
                });
            }
            else if (response.status == 401) {
                logout()
            }
            else {
                console.log("network error")
            }


        })
    }
    const logout = () => {
        localStorage.clear();
        window.location.reload();
    }

    const getCsv = () => {
        fetch(API_URL + "/session/data?session_id=" + session + "&signal_name=emg1_wave",
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': accessToken,
                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    // console.warn("result", resp);
                    if (resp.sessions[0]) {
                        // setCsvFile(resp.sessions[0].sessiondata)
                        getData(resp.sessions[0].sessiondata, "raw")
                    }

                });
            }
            else if (response.status == 401) {
                logout()
            }
            else {
                console.log("network error")
            }
        })


        fetch(API_URL + "/session/data?session_id=" + session + "&signal_name=emg1_avg",
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': accessToken,
                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    if (resp.sessions[0]) {
                        // setCsvFile(resp.sessions[0].sessiondata)
                        getData(resp.sessions[0].sessiondata, "avg")
                    }
                });
            }
            else if (response.status == 401) {
                logout()
            }
            else {
                console.log("network error")
            }


        })
    }


    async function getData(_csvFile, _stat) {
        csv('//capno-data.s3.amazonaws.com/' + _csvFile).then(data => {
            if (data.length > 2) {
                if (_stat == 'avg') {
                    setEmgAvg(true);
                }
                else if (_stat == 'raw') {
                    setEmgRaw(true)
                }
            }
        })
    }

    async function getUser() {


        fetch(API_URL + "/user/profile/" + userId,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-access-token': accessToken,
                },
            }
        ).then((response) => {
            if (response.status == 200) {
                response.json().then((resp) => {
                    setHrv(resp.owner[0].qthird);
                });
            }
            else if (response.status == 401) {
                logout()
            }
            else {
                console.log("network error")
            }


        })

    }

    return (
        <div className="demodata-bg">
            <Header />

            <div className="wrp-dashbord">
                <div className="sidebar-section">
                    <Sidebar />
                </div>
                <div className={(userType == 5 || userType == 6) ? "right-section2" : "right-section"}>

                    <div className="reportconfig-heading">
                        <div className="back-icon-wrp">
                            <Link to="/dashboard" className="backbtn-icon">
                                <img src={backIcon} alt="backicon" />
                                <span>Back</span>
                            </Link>
                        </div>
                        <div className="config-head"> <h3>{t("Preconfigured-Report")}</h3></div>

                    </div>
                    <ul className="groupreport-list">

                        {
                            sessions.map((sessions) => {
                                if ((sessions.id == 46 && qsixth) || (sessions.id == 47  && qsixth) || (sessions.id != 46 && sessions.id != 47 && sessions.id != 45) || (sessions.id == 45 && qfourth)) {

                                    return (
                                        <li><Link to={"/create/report/0/" + sessions.id + "/" + session + "/all/" + sessions.id} dangerouslySetInnerHTML={{ __html: sessions.name }} ></Link></li>
                                    )
                                }
                            }
                            )
                        }


                    </ul>
                </div>
            </div>

        </div>
    )
}

export default CreatesaveDatasession;